// extracted by mini-css-extract-plugin
export default {"submit":"Form_submit__khcqq"};